<template>
  <div>
    <Top />
    <!-- tab切换 -->
    <div class="home obor">
      <div class="title">
        <ul class="nav_tab fl">
          <li>
            <router-link
              class="span"
              title="全球"
              :to="{path:'/exp/msr/global', query: { id: '1' }}"
              :class="{onhover:currentId === '1' && currentName === 'global'}"
            >全球</router-link>
          </li>
          <li>
            <router-link
              class="span"
              title="“一带一路”沿线国家"
              :to="{path:'/exp/msr/global', query: { id: '2' }}"
              :class="{onhover:currentId === '2' && currentName === 'global'}"
            >“一带一路”沿线国家</router-link>
          </li>
          <li>
            <router-link
              class="span"
              title="中东欧国家"
              :to="{path:'/exp/msr/zdo', query: { id: '16' }}"
              :class="{onhover:currentName === 'zdo'}"
            >中东欧国家</router-link>
          </li>
        </ul>
      </div>
    </div>
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
export default {
  components: {
    Top,
    Footer
  },
  data() {
    return {
      currentId: "",
      currentName: ""
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        this.currentName = to.name;
        this.currentId = to.query.id;
      },
      immediate: true
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/exp.less";
</style>